'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function ISFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-kn36ni5o9", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-k2rpgi743", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-t8g0lquak" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-t8g0lquak", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-kn36ni5o9)" }, /* @__PURE__ */ React.createElement("use", { fill: "#0061c1", xlinkHref: "#mantine-t8g0lquak" }), /* @__PURE__ */ React.createElement("g", { fill: "#d21034", stroke: "#f1f9ff", strokeWidth: "2", mask: "url(#mantine-k2rpgi743)" }, /* @__PURE__ */ React.createElement("path", { d: "M15-1V9h18v6H15v10H9V15H-1V9H9V-1z" }))))
  );
}

export { ISFlag };
//# sourceMappingURL=IS.mjs.map
